// @ts-check
/* eslint-disable no-unused-vars */
import React, { FC, useEffect, useState, useCallback } from 'react';
/* eslint-enable no-unused-vars */
import Select from 'react-select';
import { DateRangeDropdown } from 'shared/components/DateRangeDropdown';
import { TimeRange } from './types'; // eslint-disable-line no-unused-vars
import api from 'utils/api';

/** @typedef {{
  locations: {
    id: string,
    name: string
  }[]
}} Data */

/** @typedef {{
  loading: boolean,
  data: null | Data,
  error: any
}} FetchStateModel */

/** @type { FetchStateModel } */
const defaultFetchState = {
  loading: false,
  data: null,
  error: null,
};

const allLocationsOption = {
  id: 'ALL',
  name: 'All Locations',
};

/** @typedef {{
  dateRange: TimeRange;
  locationId: string | null;
}} FilterModel */

/** @typedef {{
  value: FilterModel,
  onChange(filter: FilterModel): void
}} FilterPanelProps */

/** @type { FC<FilterPanelProps> } */
export const FilterPanel = (props) => {
  const { value: filterValue, onChange } = props;
  const { dateRange, locationId } = filterValue;

  const [{ loading, data }, setFetchState] = useState(defaultFetchState);

  const locationOptions = addAllOption((data || {}).locations || []);

  const handleChange = useCallback(
    (field) => (newValue) => onChange({ ...filterValue, [field]: newValue }),
    [onChange, filterValue]
  );

  useEffect(() => {
    setFetchState((fetchState) => ({
      ...fetchState,
      loading: true,
      error: null,
    }));
    fetchFilterValues().then((resp) => {
      setFetchState((fetchState) => ({
        ...fetchState,
        loading: false,
        error: null,
        data: resp.data,
      }));
    });
  }, []);

  return (
    <div className="flex items-start">
      <div>
        <label className="font-semibold">Date Range</label>
        <div>
          <DateRangeDropdown
            value={dateRange}
            onChange={handleChange('dateRange')}
          />
        </div>
      </div>
      <div className="ml-2">
        <label className="font-semibold">Location</label>
        <div style={{ width: 220 }}>
          <Select
            value={locationId}
            isLoading={loading || !data}
            options={locationOptions}
            placeholder="Select Location"
            labelKey="name"
            valueKey="id"
            onChange={handleChange('locationId')}
            clearable={false}
            simpleValue
          />
        </div>
      </div>
    </div>
  );
};

function fetchFilterValues() {
  return api.get('/agent_portal/api/referral_stats/filters');
}

function addAllOption(options) {
  return [allLocationsOption, ...options];
}
